import { Link } from "react-router-dom";
import { Mascot } from "./Mascot";

export const Header = () => {
  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-[#FAF8F5]/90 border-b border-[#E5DFD7]">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between gap-3">
        <Link to="/" className="flex items-center gap-2.5 group" data-testid="header-brand-logo">
          <Mascot className="w-9 h-9 ring-2 ring-[#BBE7C6] bg-[#EBF7EE] transition-transform duration-300 group-hover:-rotate-6" />
          <span className="font-display font-bold text-lg tracking-tight text-[#141915]">
            Scam<span className="text-[#15803D]">Lizard</span>
          </span>
        </Link>
        <span
          className="hidden sm:inline-flex font-mono text-[10px] font-semibold uppercase tracking-[0.14em] text-[#7B887D] border border-[#E5DFD7] bg-white rounded-full px-3 py-1.5"
          data-testid="concept-demo-pill"
        >
          Risk indicators • Not legal findings
        </span>
      </div>
    </header>
  );
};
